import axios from "axios";
import store from '@/state/store'

export const state = {
    idSessao: null,
    empresa: {},
    totem: {},
    templates: [],
    filas: [],
    senhas: [],
}

export const mutations = {
    SET_ID_SESSAO(state, payload) {
        state.idSessao = payload
        if (state.idSessao) {
            updateIdSessaoLocalStorage(state.idSessao)
        }
    },

    SET_EMPRESA(state, payload) {
        state.empresa = payload
        if (state.empresa?.idEmpresa) {
            localStorage.setItem('empresa', JSON.stringify(state.empresa))
        }
    },

    SET_TOTEM(state, payload) {
        state.totem = payload
        if (state.totem?.chaveAleatoria) {
            localStorage.setItem('totem', JSON.stringify(state.totem))
        }
    },

    SET_TEMPLATES(state, payload) {
        state.templates = payload
    },

    SET_FILAS(state, payload) {
        state.filas = payload
    },

    SET_SENHAS(state, payload) {
        state.senhas = payload
    },

    PUSH_SENHAS(state, payload) {
        state.senhas.push(payload)
    },
}

export const getters = {
    getIdSessao(state) {
        return state.idSessao
    },
}

export const actions = {
    setEmpresaTotem({ dispatch }) {
        const idEmpresa = store.getters['auth/empresaDefault']
        const idTotem = store.getters['auth/totemDefault']

        dispatch('getEmpresaDetails', idEmpresa)
        if (store.getters['auth/isAtendente'] || store.getters['auth/isGerente'] || store.getters['auth/isSupervisor']) {
            dispatch('getTotemDetails', { idEmpresa, idTotem })
        } else {
            dispatch('changeTotem', { idTotem })
        }
    },

    async getEmpresaDetails({ dispatch }, idEmpresa) {
        if(!idEmpresa) return
        return await axios.get(`privado/empresa/${idEmpresa}`).then(response => {
            dispatch('changeEmpresa', response.data)
        }).catch(() => { })
    },

    async getTotemDetails({ dispatch }, { idEmpresa, idTotem }) {
        return await axios.get(`privado/empresa/${idEmpresa}/totem/${idTotem}`).then(response => {
            dispatch('changeTotem', response.data)
        }).catch(() => { })
    },

    changeIdSessao({ commit }, payload) {
        commit('SET_ID_SESSAO', payload)
    },

    changeEmpresa({ commit }, payload) {
        commit('SET_EMPRESA', payload)
        if (payload.filas) {
            commit('SET_FILAS', payload.filas)
        }
        if (payload.idTotem && payload.chaveAleatoria) {
            commit('SET_TOTEM', { idTotem: payload.idTotem, chaveAleatoria: payload.chaveAleatoria })
        }
        store.dispatch('etotemlayout/changeCorPadrao', payload.corPadrao)
        store.dispatch('etotemlayout/changeCorFonte', payload.corFonte)
        store.dispatch('etotemlayout/changeLogo', payload.logo)
        if (payload.totens) {
            commit('SET_SENHAS', [])
            payload.totens.forEach(totem => {
                totem.senhas.forEach(senha => {
                    commit('PUSH_SENHAS', senha)
                })
            })
        }
    },

    changeTotem({ commit }, payload) {
        commit('SET_TOTEM', payload)
        if (payload.filas) {
            commit('SET_FILAS', payload.filas)
        }
    },

    changeTemplates({ commit }, payload) {
        commit('SET_TEMPLATES', payload)
        commit('SET_SENHAS', payload[0].totens[0].senhas)
    },

    changeFilas({ commit }, payload) {
        commit('SET_FILAS', payload)
    },

    changeSenhas({ commit }, payload) {
        commit('SET_SENHAS', payload)
    },

    setIdSessaoFromLocalStorage({ commit }) {
        const idSessao = localStorage.getItem('idSessao')
        if (idSessao) {
            commit('SET_ID_SESSAO', idSessao)
        }
    },

    setEmpresaFromLocalStorage({ commit }) {
        const empresa = localStorage.getItem('empresa')
        if (empresa) {
            commit('SET_EMPRESA', JSON.parse(empresa))
        }
    },

    setTotemFromLocalStorage({ commit }) {
        const totem = localStorage.getItem('totem')
        if (totem) {
            commit('SET_TOTEM', JSON.parse(totem))
        }
    },

    updateSessaoFromLocalStorage({ dispatch }) {
        dispatch('setIdSessaoFromLocalStorage')
        dispatch('setEmpresaFromLocalStorage')
        dispatch('setTotemFromLocalStorage')
    },
}

// Updates do localStorage
function updateIdSessaoLocalStorage(idSessao) {
    localStorage.setItem('idSessao', idSessao)
}
